/**
 * @fileoverview Serviço de API para gerenciamento de promoções.
 * Centraliza todas as chamadas de API relacionadas ao CRUD de promoções.
 * 
 * @module PromotionsApi
 * @since 1.0.0
 */

import { apiRequestJson } from '../api/apiService.js';

/**
 * Busca todas as promoções.
 * @returns {Promise<Array>} Lista de promoções
 */
export const getAllPromotions = async () => {
  const result = await apiRequestJson('products_promotions_list');
  const promotions = result.data?.promotions || result.data || [];
  // Normalizar: garantir que cada promoção tenha 'id' além de '_id'
  return promotions.map(promo => ({
    ...promo,
    id: promo._id || promo.id
  }));
};

/**
 * Cria uma nova promoção.
 * @param {Object} promotion - Dados da promoção
 * @returns {Promise<Object>} Promoção criada
 */
export const createPromotion = async (promotion) => {
  const result = await apiRequestJson('products_promotions_create', {
    body: promotion,
  });
  return result.data?.promotion || result.data;
};

/**
 * Atualiza uma promoção existente.
 * @param {string} id - ID da promoção
 * @param {Object} promotion - Dados atualizados da promoção
 * @returns {Promise<Object>} Promoção atualizada
 */
export const updatePromotion = async (id, promotion) => {
  const result = await apiRequestJson('products_promotions_update', {
    params: { id },
    body: promotion,
  });
  return result.data?.promotion || result.data;
};

/**
 * Remove uma promoção.
 * @param {string} id - ID da promoção
 * @returns {Promise<void>}
 */
export const deletePromotion = async (id) => {
  await apiRequestJson('products_promotions_delete', {
    params: { id },
  });
};